<template>
  <div id="app">
    <router-view></router-view>
    <!-- <outside /> -->
  </div>
</template>
<script>
export default {
  name: "app",
  // components:{outside}
};
</script>

<style>
#app {
  font-family: "SourceHanSansCN-Normal", "Microsoft YaHei", "Avenir", Helvetica,
    Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue